/**
 * OVERRIDE Breadcrumbs.jsx
 */

import Breadcrumbs from '../../../../components/Breadcrumbs/Breadcrumbs';

export default Breadcrumbs;